// Fractional indexing: the moved item's new `order` sits between its new
// neighbors' order values, so only that one item needs to be persisted
// instead of renumbering the whole list.
const GAP = 1000;

export function getReorderedOrder(items, fromIndex, toIndex) {
  const reordered = [...items];
  const [moved] = reordered.splice(fromIndex, 1);
  reordered.splice(toIndex, 0, moved);

  const prev = reordered[toIndex - 1];
  const next = reordered[toIndex + 1];

  if (prev && next) return (prev.order + next.order) / 2;
  if (prev) return prev.order + GAP;
  if (next) return next.order - GAP;
  return 0;
}
